var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import AsyncState from "../AsyncState";
import * as Utils from "../Utils";
var asyncStateReducer = function (type, asyncState, action) {
    switch (action.type) {
        case type + "__RESET":
            return AsyncState.reset(asyncState);
        case type + "__SUBMIT":
            return AsyncState.submit(asyncState);
        case type + "__REFRESH":
            return AsyncState.refresh(asyncState);
        case type + "__PENDING":
            return AsyncState.pending(asyncState);
        case type + "__RESOLVED":
            return AsyncState.resolve(asyncState, action.payload, action.extra);
        case type + "__REJECTED":
            return AsyncState.reject(asyncState, action.payload);
        default:
            return asyncState;
    }
};
export var createAsyncStateReducer = function (types) {
    return function (state, action) {
        var copy = null;
        var keys = Object.keys(types);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var type = types[key];
            var current = state[key];
            var updated = asyncStateReducer(type, current, action);
            if (current !== updated) {
                if (!copy) {
                    copy = __assign({}, state);
                }
                copy[key] = updated;
            }
        }
        return copy || state;
    };
};
var actionCreator = function (type) {
    return Utils.assign(function (payload, extra) {
        return {
            type: type,
            payload: payload,
            extra: extra,
        };
    }, { type: type });
};
var lockIdCounter = 0;
var locks = {};
var actionCreatorsImpl = function (type, handler) {
    var creators = Utils.assign(function (payload) {
        return creators.submit(payload);
    }, {
        type: type,
        reset: actionCreator(type + "__RESET"),
        submit: actionCreator(type + "__SUBMIT"),
        refresh: actionCreator(type + "__REFRESH"),
        pending: actionCreator(type + "__PENDING"),
        resolved: actionCreator(type + "__RESOLVED"),
        rejected: actionCreator(type + "__REJECTED"),
    });
    if (typeof handler === "function") {
        var injectEnhancedMethod = function (name, creators, handler) {
            var original = creators[name];
            creators[name] = function (payload, extra) {
                return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
                    var operationId, dispatchIfStillCurrentOp, pendingTimeout, actionType, action, result, error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                operationId = lockIdCounter++;
                                locks[type] = operationId;
                                dispatchIfStillCurrentOp = function (action) {
                                    if (locks[type] === operationId) {
                                        dispatch(action);
                                    }
                                };
                                pendingTimeout = setTimeout(function () { return dispatchIfStillCurrentOp(original(payload)); }, 200);
                                actionType = type + "__" + name.toUpperCase();
                                action = { type: actionType, payload: payload, extra: extra };
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, 4, 5]);
                                return [4 /*yield*/, handler(action, dispatch, getState)];
                            case 2:
                                result = _a.sent();
                                return [2 /*return*/, dispatchIfStillCurrentOp(creators.resolved(result))];
                            case 3:
                                error_1 = _a.sent();
                                console.error(actionType + ":", error_1);
                                return [2 /*return*/, dispatchIfStillCurrentOp(creators.rejected(error_1))];
                            case 4:
                                clearTimeout(pendingTimeout);
                                return [7 /*endfinally*/];
                            case 5: return [2 /*return*/];
                        }
                    });
                }); };
            };
        };
        injectEnhancedMethod("submit", creators, handler);
        injectEnhancedMethod("refresh", creators, handler);
        return creators;
    }
    return creators;
};
export var asyncStateActionCreators = function (type) {
    return actionCreatorsImpl(type, undefined);
};
export var asyncStateActionCreatorsThunk = function (type, handler) {
    return actionCreatorsImpl(type, handler);
};
